// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3OaOS","tab":"Tabs_tab__1JtG1","tabActive":"Tabs_tabActive__3fQRv"};